import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://c6cec951b651da0bd0f8b3027175ec52@o4505720600002560.ingest.us.sentry.io/4507312828973056",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});